export enum Status {
  Error = 'error',
  Success = 'success',
}

export type Validation = {
  status: Status
  text?: string
  fields?: string[]
}

export enum StatusMessage {
  EmptyField = 'Please provide an answer',
}
